// extracted by mini-css-extract-plugin
export default {"mainWrraper":"style_mainWrraper__UODb8","saveAndQuitImg":"style_saveAndQuitImg__OdfLw"};